import { Flex, Spin, Switch } from 'antd';

import BaseText from '@components/typography/BaseText';

import { Note, PanelRow } from './FindPanel';
import { SIMILARITY_STATUS } from './useSimilarityMap';

/**
 * The heatmap row: how alike every spot of the whole orthophoto is to the examples, in colours,
 * and its strongest spots as dots. It is precomputed, so it covers the whole map; a search runs
 * only in the area. While it shows, a click on an object adds it (SAM 3 outlines it).
 */
const HeatmapRow = ({ status, featuresState, heatmapVisible, setHeatmapVisible, spots }) => (
	<PanelRow label="Heatmap">
		<Flex align="center" gap="small">
			<Switch
				checked={heatmapVisible}
				onChange={setHeatmapVisible}
				disabled={status !== SIMILARITY_STATUS.READY}
				aria-label="Show the heatmap"
			/>
			<BaseText>Whole map</BaseText>
			{heatmapVisible && status === SIMILARITY_STATUS.LOADING && <Spin size="small" />}
		</Flex>
		{status === SIMILARITY_STATUS.UNAVAILABLE && (
			<Note>
				{featuresState === 'computing'
					? 'Being computed for this orthophoto. Finding still works.'
					: 'Not computed for this orthophoto yet. Finding still works.'}
			</Note>
		)}
		{heatmapVisible && status === SIMILARITY_STATUS.READY && (
			<Note>
				Colours: how alike each spot is; dots: the strongest ({spots.length} in view). Click
				an object to add it.
			</Note>
		)}
	</PanelRow>
);

export default HeatmapRow;
